var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialChangeStatus',{ref:"dialChangeStatus",attrs:{"orderId":_vm.orderId}})
}
var staticRenderFns = []

export { render, staticRenderFns }